<template>
  <div id="Allbtn" v-if="routeList">
    <!-- 考试的求助 -->
    <div v-if="showHelp" class="faceTipBox cursor">
      <faceTipBox1></faceTipBox1>
    </div>
    <!-- 咨询 -->
    <div v-if="!showHelp" class="advisory cursor" @click="advisoryFn">
      <img :src="$t('flowImage12')" alt="" class="erCode2" v-if="showCode">
      <div id="h5lxwm" class="ContactUs"></div>
    </div>
    <!-- 回到顶部 -->
    <div class="top btn_box" @mouseover="infoMouseover" @mouseout="infoMouseout" v-if="$route.meta.Allbtn_info && !showHelp " >
      <!-- 消息 -->
      <div class="info" v-if="$route.meta.Allbtn_info">
        <!--        <div class="info_new" v-if="noticeNo != 0">-->
        <!--          NEW-->
        <!--        </div>-->
        <transition name="fade">
          <!-- 没有未读的公告 -->
          <div class="no_info" v-if="infoDialog && (noticeNo === 0)">
            <div class="no_info_title">(*^__^*) {{$t('flowFollowUs1')}}</div>
            <div class="no_info_text">
              <span class="cursor" @click="toNotice">{{$t('flowFollowUs2')}}</span>
            </div>
          </div>
          <!-- 有未读公告 -->
          <div class="yes_info" v-else-if="infoDialog">
            <div class="yes_info_top">(●ﾟωﾟ●) {{$t('flowFollowUs3')}}</div>
            <div class="yes_info_li cursor"
                 @click="toInfo(item)"
                 v-for="item in noticeList"
                 :key="item.noticeId">
              <div class="yes_info_li_title">
                {{item.noticeTitle}}
              </div>
              <div class="yes_info_li_time">
                {{item[$t('flowMessage39')] ? item[$t('flowMessage39')] : item.publishTimeStr}}
              </div>
            </div>
            <div class="yes_info_bottom">
              <span class="cursor" @click="toNotice">{{$t('flowFollowUs4')}}</span>
            </div>
          </div>
        </transition>
        <!-- <transition name="fade">
        </transition> -->
      </div>
      <div class="btn cursor">
        <img src="https://img.webloom.cn/img/gongao.png" alt="">
      </div>
    </div>
    <div class="top btn_box" v-if="!showHelp">
      <div class="btn cursor" @mouseover="showCodeEnter"  @mouseout="showCodeOut">
        <img src="https://img.webloom.cn/img/weixinCode.png" alt="" class="discoloration">
        <div class="btnInner">
          <!-- <div class="empty"></div> -->
          <div :class="$i18n.locale !== 'en' ? 'btnInnerText' : 'btnInnerText1'">{{$t('flowFollowUs5')}}</div>
        </div>
      </div>
    </div>
    <div class="top btn_box" v-if="!showHelp">
      <div class="btn cursor" @click="toComplaint">
        <img src="https://img.webloom.cn/img/liaxi.png" alt="" class="discoloration">
        <div class="btnInner">
          <!-- <div class="empty"></div> -->
          <div :class="$i18n.locale !== 'en' ? 'btnInnerText' : 'btnInnerText1 btnInnerText2'">{{$t('flowFollowUs6')}}</div>
        </div>
      </div>
    </div>
    <div class="top btn_box" v-if="!showHelp">
      <div class="btn cursor" @click="$utils.backTop(1000)" v-if="topBol">
        <img src="https://img.webloom.cn/img/toTop.png" alt="">
      </div>
    </div>
    <span v-show="false">{{language}}</span>
    <speakToStudent v-if="showHelp" :showHelp="showHelp"></speakToStudent>
    <!--公告弹窗-->
    <el-dialog
      custom-class="task_list_dialog_all"
      :modal="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
      :lock-scroll="true"
      width="1000px">
      <div slot="title" class="dialog-title-all">
        <div class="title-right">
          <img src="https://img.webloom.cn/img/gonggaoicontc.png" alt="" class="iconImg">
          <div class="title">{{dialogTitle.title}}</div>
        </div>
        <div class="time">{{dialogTitle.time}}</div>
      </div>
      <noticeInfo :model="2" :noticeId="userLatestNoticeInfo.noticeId || ''" v-if="dialogVisible" :topicId="$route.params.seasonId" @getdialogTitle="getdialogTitle" @close="toclose" :noticeNo="noticeNo"></noticeInfo>
    </el-dialog>
  </div>
</template>

<script>
import SVGA from 'svgaplayerweb'
import faceTipBox1 from '../bloom-proctor/public/faceTipBox.vue'
import speakToStudent from '../bloom-proctor/public/speakToStudent.vue'
import {loginTim, logoutTim, JoinGroupIM} from '../bloom-proctor/public/createIMClient'
import { mapState, mapMutations } from 'vuex'
import CloseStream from '../bloom-proctor/public/closeStream'
import noticeInfo from '../team-message/notice-info.vue'
export default {
  components: {
    noticeInfo,
    faceTipBox1,
    speakToStudent
  },
  computed: mapState({
    tim: state => state.test.tim,
    imGroupId: state => state.proctor.imGroupId,
    joinGroupSuccess: state => state.proctor.joinGroupSuccess,
    timerCamera: state => state.proctor.timerCamera,
    cameraClient: state => state.proctor.cameraClient,
    cameraStream: state => state.proctor.cameraStream,
    timerErrorCamera: state => state.proctor.timerErrorCamera,
    // 是否含有该路由
    routeList () {
      for (let i in this.pathList) {
        if (this.$route.path.toUpperCase().indexOf(this.pathList[i].toUpperCase()) > -1) {
          return false
        }
      }
      return true
    },
    // 求助是否展示
    showHelp () {
      for (let i in this.helpList) {
        if (this.$route.path.toUpperCase().indexOf(this.helpList[i].toUpperCase()) > -1) {
          return true
        }
      }
      return false
    },
    language () {
      this.getSvga()
      return this.$i18n.locale === 'en' ? 'en' : 'zh'
    }
  }),
  data () {
    return {
      dialogTitle: {
        title: '',
        time: ''
      },
      topicId: '',
      dialogVisible: false,
      noticeNo: 0,        // 未读公告数量
      noticeList: [],     // 公告列表
      userLatestNoticeInfo: {}, // 弹窗信息对象
      infoDialog: false,  // 消息弹窗
      infoTimer: null,
      infoBolTimer: null, // 有未读时的弹框
      topBol: false,      // 返回顶部按钮显示隐藏
      // 写作，考试，和tdpt
      pathList: ['tdpt/', '/ExamPaper', '/WritingTask', '/AnswerRoom', '/QuestionRoom'],   // 不要显示的路由
      // 监考,迟到,进入考试页,考试结束
      helpList: ['/bloomEquipment', '/waitingExamination', '/BattleList', '/BattleRoom', '/BattleResult', '/SuperQuizNew', '/SuperQuizPaperNew', '/SuperQuizEndNew', '/ExamSystemMiss', '/ExamSystemIndex', '/ExamSystemEnd', '/ExamSystemPaper', '/ExamSystemEND'],
      showCode: false
    }
  },
  methods: {
    ...mapMutations(['set_imMessageList', 'set_timerCamera', 'set_TIMMessage', 'set_timerErrorCamera', 'set_joinGroupSuccess']),
    // 信息的移进来
    getdialogTitle (e) {
      this.dialogTitle = e
    },
    toclose () {
      this.dialogVisible = false
    },
    infoMouseover () {
      clearTimeout(this.infoTimer)
      clearTimeout(this.infoBolTimer)
      this.infoDialog = true
    },
    // 信息的移出去
    infoMouseout () {
      this.infoTimer = setTimeout(() => {
        this.infoDialog = false
      }, 300)
    },
    showCodeEnter (e) {
      clearTimeout(this.showCodeTimer)
      this.showCode = true
    },
    showCodeOut () {
      this.showCodeTimer = setTimeout(() => {
        this.showCode = false
      }, 200)
    },
    // 跳转立即执行
    advisoryFn () {
      this.$router.push('/contact')
      this.$utils.CzcTrackEvent(this.$route.name, '全局报名咨询点击', '')
    },
    // 滚动条事件
    scrollup (e) {
      // 变量t是滚动条滚动时，距离顶部的距离
      let t = document.documentElement.scrollTop || document.body.scrollTop
      // 当滚动到距离顶部200px时，返回顶部的锚点显示
      this.topBol = t >= 200
    },
    // 去公告详情
    toInfo (item) {
      if (item.isRead === 0) {
        item.isRead = 1
        this.noticeNo = this.noticeNo - 1
        // 未读公告减一
      }
      this.userLatestNoticeInfo = item
      this.dialogVisible = true
      // this.$router.push({
      //   path: '/NoticeInfo',
      //   query: {
      //     topicId: this.$route.params.seasonId,
      //     noticeId: item.noticeId
      //   }
      // })
    },
    toComplaint () {
      this.$router.push('/complaint')
      this.$utils.CzcTrackEvent(this.$route.name, '全局投诉点击', '')
    },
    // 获取公告信息
    getNoticeInfo () {
      console.log('asxadadadasdasd')
      let data = {
        businessId: this.$route.params.seasonId
      }
      this.$api.post('GET_UNREADCOUNT', data, (res) => {
        this.noticeNo = res.data.noticeNum || 0
        // 更新活动消息
        let activityNum = res.data.activityNum || 0
        let num = activityNum + this.noticeNo
        this.$store.commit('setActNum', num)
        if (+this.noticeNo !== 0) {
          this.getNoticeList()
        }
      })
      // this.$api.post('COMMON_NOTICE_NUM', data, res => {
      //   // this.getNoticeList()
      //   this.noticeNo = res.data || 0
      //   if (+res.data !== 0) {
      //     // 获取公告列表
      //     this.getNoticeList()
      //   }
      // })
    },
    // 获取未读公告列表
    getNoticeList () {
      let data = {
        topicId: this.$route.params.seasonId,
        startIndex: 0,
        pageSize: 3
      }
      this.$api.post('COMMON_NOTICE_UNREAD', data, res => {
        this.noticeList = res.data.noticeList || []
        this.noticeList = this.noticeList.map(e => {
          e.isRead = 0
          return e
        })
        this.userLatestNoticeInfo = res.data.userLatestNoticeInfo || null // 弹窗信息
        this.infoDialog = true
        if (this.userLatestNoticeInfo && this.userLatestNoticeInfo.isRead === 0) {
          this.dialogVisible = true
          this.noticeNo = this.noticeNo - 1
          this.noticeList[0].isRead = 1 // 自动弹窗的公告直接已读
        }
        this.infoBolTimer = setTimeout(() => {
          this.infoDialog = false
        }, 3000)
      })
    },
    // 去公告列表
    toNotice () {
      this.$router.push({
        path: '/teamMessage',
        query: {
          topicId: this.$route.params.seasonId,
          contestId: this.$route.query.contestId,
          type: 1
        }
      })
    },
    logonIm () {
      if (this.showHelp) {
        this.$api.post('COMMON_GET_USER_SIG', {}, (res) => {
          let userSig = res.data.userSig || ''
          let appid = res.data.sdkAppId
          let userId = ''
          if (JSON.parse(this.$utils.cache('userData'))) {
            userId = JSON.parse(this.$utils.cache('userData')).userId
          }
          loginTim(appid, userId, userSig, { examId: this.$route.query.examId }, res => {
            try { console.log('静静的im登录', JSON.parse(res.data[0].payload.text)) } catch (error) {}
            this.set_imMessageList(res)
            // if (this.imGroupId) {
            //   JoinGroupIM({ groupID: this.imGroupId }, res => {
            //     console.log('加群成功')
            //   })
            // }
          })
        })
      }
    },
    // 初始化
    init () {
      window.addEventListener('scroll', this.scrollup, false)
      this.getSvga()
    },
    // 获取Svga图标
    getSvga () {
      let url = ''
      // 一定要使用$nextTick，等到页面加载完成再处理数据，否则会找不到页面元素，报Undefind的错误
      this.$nextTick(() => {
        let player = new SVGA.Player('#h5lxwm')   // 多个svga文件同时加载
        let parser = new SVGA.Parser('#h5lxwm')       // 多个svga文件同时加载
        // 若是单个文件，则直接获取其Id即可
        url = this.$t('flowImage2')
        parser.load(url, function (item) {
          player.setVideoItem(item)
          player.startAnimation()
        })
      })
    }
  },
  created () {
    console.log(this.$route, 'this.$route')
    this.topicId = this.$route.params.seasonId
    this.init()
  },
  watch: {
    '$route' () {
      if (this.$route.meta.Allbtn_info) {
        this.infoDialog = false
        // 获取公告信息
        this.getNoticeInfo()
      }
    },
    imGroupId: {
      immediate: true,
      deep: true,
      handler: function (val) {
        console.log(11111111, val)
        if (val && this.tim) {
          JoinGroupIM({ groupID: this.imGroupId }, res => {
            this.set_joinGroupSuccess(true)
          })
        }
      }
    },
    tim: {
      immediate: true,
      deep: true,
      handler: function (val) {
        console.log(this.imGroupId, val)
        if (this.imGroupId && val) {
          JoinGroupIM({ groupID: this.imGroupId }, res => {
            console.log('加群成功')
          })
        }
      }
    },
    showHelp (val) {
      if (val) {
        this.logonIm()
        sessionStorage.setItem('bloom-pc-TimExamId', this.$route.query.examId)
      } else {
        logoutTim()
        if (this.timerErrorCamera) {
          clearInterval(this.timerErrorCamera)
          this.set_timerErrorCamera(null)
        }
        this.set_TIMMessage({})
      }
      if (!val) {
        CloseStream(true, false)
      }
    }
  }
}
</script>
<style lang="scss">
.task_list_dialog_all{
  .dialog-title-all{
    //display: flex;
    font-size: 18px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #303133;
    padding-bottom: 10px;
    text-align: center;
    position: relative;
    line-height: 22px;
    .time{
      position: absolute;
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #9499A4;
      right: 34px;
      top: 0;
    }
    .iconImg {
      display: block;
      width: 108px;
      height: 56px;
      position: absolute;
      left: -12px;
      top: -12px;
    }
    .title{
      padding: 0 200px;
    }
  }
  .el-dialog__body{
    padding: 0!important;
  }
  .el-dialog__header {
    padding: 23px 20px 15px;
    background: linear-gradient(360deg, #FFFFFF 0%, #FFFFFF 16%, #D7E3FF 100%)!important;
  }
  .el-dialog__headerbtn {
    top: 25px
  }

}
  #Allbtn {
    .el-dialog__body{
      padding: 0!important;
    }
  }
</style>
<style lang="scss" scoped>
#Allbtn{
  .faceTipBox{
    position:fixed;
    bottom: 24px;
    right: 24px;
  }
  position: fixed;
  z-index: 3000;
  bottom: 80px;
  right: 10px;
  .btn_box{
    width: 68px;
    height: 68px;
    margin-top: 8px;
    margin-left: 20px;
    .btn{
      color: #C0C6CA;
      text-align: center;
      img{
        width: 68px;
        height: 68px;
      }
      .blpc{
        line-height: 40px;
      }
    }
    .btnInner{
      text-align: center;
      width: 68px;
      height: 68px;
      border-radius: 50%;
      padding: 14px 0 14px 10px;
      box-sizing: border-box;
      display: none;
      background-color: #1775FF;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      .btnInnerText{
        width: 58px;
        height: 40px;
        line-height: 20px;
        white-space: pre-wrap;
        word-break: break-word;
        letter-spacing: 10px;
      }
      .btnInnerText1{
        width: 100%;
        height: 40px;
        line-height: 20px;
        white-space: pre-line;
        word-break: break-word;
        padding-right: 20px;
        font-size: 13px;
      }
      .btnInnerText2{
        width: 60px;
        margin-right: 30px;
        line-height: 40px;
      }
      .empty{
        // margin-bottom: 10px;
        // height: 1px;
      }
    }
    .btn:hover{
      //background-color: #1775FF;
      //color: #fff;
      //img {
      //  display: none;
      //}
    }
  }
  .btn_box:hover{
    .btn{
      .discoloration {
        display: none;
      }
      .btnInner{
        display: block;
      }
    }
  }
  .info{
    position: relative;
    .info_new{
      width: 37px;
      height: 20px;
      position: absolute;
      top: -10px;
      left: -18px;
      background: #FF3049;
      border-radius: 4px;
      line-height: 20px;
      text-align: center;
      font-size: 12px;
      color: #fff;
    }
    .no_info{
      position: absolute;
      width: 304px;
      height: 120px;
      background: #FFFFFF;
      box-shadow: 0 -2px 4px 0 #F4F9FF, 0 8px 16px 0 #F5F7FA;
      border: 4px;
      left: -330px;
      top: -40px;
      text-align: center;
      padding-top: 32px;
      box-sizing: border-box;
      .no_info_title{
        font-size: 16px;
        line-height: 21px;
        margin-bottom: 16px;
      }
      .no_info_text{
        line-height: 19px;
        color: #296BFF;
      }
    }
    .no_info::after{
      content: '';
      display: block;
      position: absolute;
      border-bottom: 6px solid transparent;
      border-top: 6px solid transparent;
      border-left: 8px solid #FFFFFF;
      border-right: 8px solid transparent;
      right: -16px;
      top: 54px;
    }
    .yes_info{
      width: 304px;
      position: absolute;
      left: -340px;
      bottom: -200px;
      background: #fff;
      box-shadow: 0 -2px 4px 0 #F4F9FF, 0 8px 16px 0 #F5F7FA;
      border-radius: 8px;
      .yes_info_top{
        color: #fff;
        border-radius: 8px 8px 0 0;
        padding-left: 16px;
        font-size: 16px;
        line-height: 48px;
        background-image: linear-gradient(269deg, #469EFF 0%, #296BFF 100%);
      }
      .yes_info_li{
        padding: 16px 28px;
        border-bottom: 1px solid #F1F1F2;
        .yes_info_li_title{
          line-height: 19px;
          margin-bottom: 8px;
          position: relative;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .yes_info_li_title::after{
          content: '';
          display: block;
          width: 4px;
          height: 4px;
          background: #FF3049;
          border-radius: 50%;
          position: absolute;
          left: -12px;
          top: 8px;
        }
        .yes_info_li_time{
          color: #D4D6DB;
          font-size: 12px;
          line-height: 16px;
        }
      }
      .yes_info_bottom{
        line-height: 50px;
        color: #296BFF;
        text-align: center;
        border-radius: 0 0 8px 8px;
      }
    }
  }
  .top .btn, .info .btn{
    font-size: 32px;
  }
  .advisory{
    margin-top: 4px;
    //width: 40px;
    font-size: 0;
    line-height: 0;
    position: relative;
    right: 14px;
    .ContactUs{
        width: 120px;
        height: 120px;
        display: block;
        //position: absolute;
    }
    .erCode2{
      width: 245px;
      height: 184px;
      position: absolute;
      top: 70px;
      left: -249px;
      //display: none;
    }
    //img{
    //  width: 100%;
    //}
    .advisory_hover{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba($color: #000000, $alpha: 0.1);
      border-radius: 4px;
      display: none;
    }
  }
  .advisory:hover .advisory_hover{
    display: block;
  }
  .testHelp{
    margin-top: 4px;
    margin-right: 20px;
    position: relative;
    height:40px;
    color:white;
    font-size: 16px;
    .testHelpBox{
      width: fit-content;
      line-height: 20px;
      background: #469EFF;
      padding: 10px;
    }
    .testHelp_hover{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba($color: #000000, $alpha: 0.1);
      border-radius: 4px;
      display: none;
    }
  }
  .testHelp:hover .testHelp_hover{
    display: block;
  }
  .task_list_dialog{
    background: #0BC2C1;

  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/all-btn.vue